/** @format */

import React, { Suspense } from 'react';
import { PrivateRoute } from 'modules';
import { Box } from '@mui/material';

export interface IRootProps { }

export const RootLayout = (props: IRootProps) => {


  return (
    <PrivateRoute.FC />
  );
};
